var map = {
	"./template.betgalaxy": 2059,
	"./template.betgalaxy.tsx": 2059,
	"./template.betprofessor": 1142,
	"./template.betprofessor.tsx": 1142,
	"./template.betroyale": 1143,
	"./template.betroyale.tsx": 1143,
	"./template.default": 659,
	"./template.default.tsx": 659,
	"./template.fiestabet": 1144,
	"./template.fiestabet.tsx": 1144,
	"./template.puntcity": 1145,
	"./template.puntcity.tsx": 1145,
	"./template.puntgenie": 1146,
	"./template.puntgenie.tsx": 1146,
	"./template.questbet": 1147,
	"./template.questbet.tsx": 1147,
	"./template.ts": 970,
	"./template.volcanobet": 1148,
	"./template.volcanobet.tsx": 1148,
	"./template.wellbet": 1149,
	"./template.wellbet.tsx": 1149
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2431;